// icons-map.js — auto-generated JS
import { iconsMap as _iconsMap } from "./icons-map.js";

// Приводим auto-generated карту к словарю
const iconsMap: Record<string, any> = _iconsMap;

export const icons: Record<string, string> = {};

Object.keys(iconsMap).forEach((key: string) => {
    const mod = iconsMap[key];

    // raw-loader (Webpack 5) возвращает объект { default: "<svg...>" }
    let raw = (mod && typeof mod === "object" && "default" in mod)
        ? mod.default
        : mod;

    // 👉 НОРМАЛИЗАЦИЯ SVG (ЗДЕСЬ!)
    // Заменяем все stroke/fill на currentColor
    raw = raw
        .replace(/stroke="[^"]*"/g, 'stroke="currentColor"')
        .replace(/fill="[^"]*"/g, 'fill="currentColor"');

    icons[key] = raw;
});

export type IconKey = keyof typeof icons;
